import { render } from "./Or_tableSupply.vue?vue&type=template&id=370526ba&scoped=true&ts=true"
import script from "./Or_tableSupply.vue?vue&type=script&lang=ts"
export * from "./Or_tableSupply.vue?vue&type=script&lang=ts"

import "./Or_tableSupply.vue?vue&type=style&index=0&id=370526ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370526ba"]])

export default __exports__